import { MTextBlockSimpleProps } from '../../molecules/MTextBlockSimple/MTextBlockSimple.types';
import { MButtonProps } from '../../molecules/MButton/MButton.types';
import { MMediaSelectorProps } from '../../molecules/MMediaSelector/MMediaSelector.types';

export enum OCardFeatureContentAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export enum OCardFeatureLayout {
  Default = 'Default',
  Reverse = 'Reverse',
}

export interface OCardFeatureTrackingProperties {
  location?: string;
  trackingTag?: string;
  trackingContentPosition?: string;
  trackingDescription?: string;
  trackingOfferType?: string;
  merchandisingCategory?: string;
  atCCeVar48?: string;
  faicUrl?: string;
  clickTrack?: boolean;
  impressionTrack?: boolean;
  impressionCount?: boolean;
  enableScrollingBehavior?: boolean;
  leftArrowDesc?: string;
  cardLocation?: string;
  rightArrowDesc?: string;
  description?: string;
  faicMCD?: string;
  additionalTrackingVariables?: string;
}

export interface OCardFeatureProps {
  contentAlignment?: OCardFeatureContentAlignment;
  layout?: OCardFeatureLayout;
  mTextBlockSimple?: MTextBlockSimpleProps;
  mButton?: MButtonProps;
  mButton2?: MButtonProps;
  mMediaSelector?: MMediaSelectorProps;
  className?: string;
  trackingProperties?: OCardFeatureTrackingProperties;
}
